import { Component } from '@angular/core';

@Component({
  selector: 'app-fee-help',
  templateUrl: './fee-help.component.html'
})
export class FeeHelpComponent {

}
